<div *ngIf="isNotificationVisible" class="notification">
  <i class="bi bi-check-circle-fill notification-icon"></i>
  <span class="notification-text">Se modificó el despacho exitosamente.</span>
  <i class="bi bi-x-lg close-icon" (click)="hideNotification()"></i>
</div>

<div class="d-flex align-items-center flex-nowrap history-heading mb-2">
  <div class="flex-grow-1">
    <h6 class="pl-4 mb-0">Revisa aquí los despachos pasados de Hormigón.</h6>
  </div>
  <div class="flex-shrink-0">
    <a (click)="updateUrl()" class="btn button-actualizar"
      ><i class="bi bi-arrow-clockwise me-2"></i>Actualizar</a
    >
  </div>
</div>

<div class="dashboard dashboard-center history-page">
  <div class="tab-content">
    <div *ngIf="activeTab === 1">
      <app-filtro-resumen-guias
        [fechaMaxima]="fechaMaximaVueltas"
        [fechaMinima]="fechaMinimaVueltas"
        [total]="totalVueltas"
        (eventoFiltrar)="filtrarPorFechas($event)"
      ></app-filtro-resumen-guias>
      <div class="row">
        <div class="col-md-6 mb-2">
          <h5>Vueltas por Semana</h5>
          <canvas
            baseChart
            [datasets]="chartData"
            [labels]="chartLabels"
            [type]="'bar'"
            [options]="chartOptions"
          ></canvas>
        </div>
        <div class="col-md-6 mb-2">
          <h5>Guías</h5>
          <canvas
            baseChart
            [data]="firmadasChartData"
            [options]="firmadasChartOptions"
            [type]="'pie'"
          ></canvas>
        </div>
      </div>
      <table class="table table-striped mb-5">
        <thead>
          <tr>
            <th>Ticket</th>
            <th>Obra</th>
            <th>Dirección</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of datosTabla">
            <td>{{ item.ticket }}</td>
            <td>{{ item.obra }}</td>
            <td>{{ item.direccion }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-alert></app-alert>
  <app-ui-filters
    [formGroup]="filtrosForm"
    [asDropdown]="true"
    (clear)="limpiarFiltros()"
  >
    <div class="filters" uiFiltersFields>
      <div class="search-input">
        <input
          type="text"
          class="form-control"
          placeholder="N° pedido"
          aria-label="Buscar por N° pedido"
          formControlName="numeroPedido"
        />
        <i class="bi bi-search" aria-hidden="true"></i>
      </div>
      <div class="search-input">
        <input
          type="text"
          class="form-control"
          placeholder="N° Guía"
          aria-label="Buscar por N° Guía"
          formControlName="numeroGuia"
        />
        <i class="bi bi-search" aria-hidden="true"></i>
      </div>
      <div
        class="date-range-wrapper date-range-trigger"
        role="button"
        tabindex="0"
        aria-label="Seleccionar rango de fechas"
        (click)="picker.open()"
      >
        <span class="date-range-placeholder">{{ dateRangeLabel() }}</span
        ><mat-date-range-input
          class="date-range-input-hidden"
          [rangePicker]="picker"
          separator="| Hasta"
          ><input
            matStartDate
            aria-label="Fecha desde"
            formControlName="fechaDesde" /><input
            matEndDate
            aria-label="Fecha hasta"
            formControlName="fechaHasta" /></mat-date-range-input
        ><mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle
        ><mat-date-range-picker #picker></mat-date-range-picker>
      </div>
      <select class="form-control" formControlName="estado">
        <option value="" disabled>Estado</option>
        <option>Entregado</option>
        <option>Pendiente</option>
        <option>Anulado</option>
        <option>Todos</option>
      </select>
      <select class="form-control" formControlName="firma">
        <option value="" disabled>Firma</option>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
    <button
      type="button"
      class="btn btn-toolbar-text"
      uiFiltersDesktopActions
      (click)="modalExporta.open()"
    >
      Exportar <i class="bi bi-download ml-1"></i>
    </button>
    <button
      type="button"
      class="btn btn-compact-icon"
      uiFiltersPanelActions
      aria-label="Exportar"
      (click)="modalExporta.open()"
    >
      <i class="bi bi-download"></i>
    </button>
  </app-ui-filters>

  <app-ui-table
    [rows]="orders"
    [columns]="tableColumns"
    [mobileColumns]="mobileTableColumns"
    [templates]="{
      signature: signatureTemplate,
      guide: guideTemplate,
      status: statusTemplate,
      actions: actionsTemplate,
    }"
    [rowTitle]="rowTitle"
    tableClass="ui-table--fit"
    emptyText="No se encontraron registros."
  ></app-ui-table>
  <p class="text-muted small mt-2 mb-0">
    Cantidad de registros: {{ orders.length }}
  </p>

  <app-modal-exportar
    #modalExporta
    [title]="modalTitle"
    [message]="modalMessage"
    [buttonText]="'Exportar'"
    [data]="getExportRows()"
    [nameFile]="'historialHormigon'"
  ></app-modal-exportar>
  <app-hormigon-history-detail
    #detallePedido
    [order]="order"
    [isRejected]="isRejected.bind(this)"
    [isDelivered]="isDelivered.bind(this)"
    [isPending]="isPending.bind(this)"
    (updated)="showNotification()"
    (signed)="updateUrl()"
  ></app-hormigon-history-detail>

  <ng-template #signatureTemplate let-order>
    <span
      [class.text-success]="isSigned(order)"
      [class.text-danger]="!isSigned(order)"
      >{{ isSigned(order) ? "Si" : "No" }}</span
    >
  </ng-template>
  <ng-template #guideTemplate let-order>
    <app-pedidos-pendiente-visualizarguia
      [rutaPdf]="order.routePdfGuide"
      [tkt]="order.tkt.toString()"
      [numGuia]="order.folioNumberGD"
    ></app-pedidos-pendiente-visualizarguia>
  </ng-template>
  <ng-template #statusTemplate let-order>
    <div *ngIf="isDelivered(order)" class="status is-success">
      <i class="bi bi-check-square"></i> Entregado
    </div>
    <div *ngIf="isPending(order)" class="status is-pending">
      <i class="bi bi-exclamation-triangle"></i> Pendiente
    </div>
    <div *ngIf="isRejected(order)" class="status is-danger">
      <i class="bi bi-x-square"></i> Anulado
    </div>
  </ng-template>
  <ng-template #actionsTemplate let-order>
    <div class="row-actions">
      <button class="btn btn-link" (click)="goDetalle(order)">Ver más</button>
      <button
        *ngIf="
          order.rejectionFlag === '' &&
          ((order.isDigitalSignature && !order.isSignature) ||
            (order.status < 6 && !order.isSignature))
        "
        class="btn btn-link"
        (click)="generateQr(order)"
      >
        QR
      </button>
    </div>
  </ng-template>

</div>
